module.exports = __webpack_public_path__ + "media/bootstrap-icons/truck-5d591e19.svg";